import { createFileRoute } from '@tanstack/react-router';

import { PersonalDetailsPage } from '../user/personal/PersonalDetailsPage';

export const Route = createFileRoute('/_app/me')({
    component: PersonalDetailsPage,
});
